import React, { useEffect, useRef } from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const stepsRef = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    stepsRef.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const steps = [
    {
      number: '01',
      title: 'Field Analysis & Planning',
      description: 'Our AI system analyzes your field conditions, crop requirements, and soil composition to create an optimal irrigation layout plan.'
    },
    {
      number: '02',
      title: 'Robotic Installation',
      description: 'Autonomous robots deploy and install the drip irrigation system with precision, reducing installation time from weeks to hours.'
    },
    {
      number: '03',
      title: 'Smart Water Management',
      description: 'Intelligent sensors monitor soil moisture and weather conditions to deliver the exact amount of water needed for optimal crop growth.'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2>How It Works</h2>
        <p className="section-subtitle">
          Our three-step process transforms traditional farming with automated drip irrigation technology that's accessible to every farmer.
        </p>
        
        <div className="steps">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="step"
              ref={el => stepsRef.current[index] = el}
            >
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
